import {Component, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {FontAwesomeService} from "@services/font-awesome.service";

@Component({
  selector: 'app-table',
  template: `
    <div class="table-container">
      <table>
        <tr>
          <th *ngIf="checkboxSign" style="width: 50px;">
            <mat-checkbox *ngIf="data"
              color="primary"
              (change)="handleSelectAll($event)"
              [checked]="isAllSelected"></mat-checkbox>
          </th>
          <th *ngFor="let row of rows;">{{row.label}}</th>
          <th *ngIf="deleteSign" style="width: 50px;"></th>
        </tr>
        <tr *ngFor="let element of data; trackBy: trackByFn">
          <td *ngIf="checkboxSign " style="width: 50px;">
            <mat-checkbox
              #checkbox
              color="primary"
              (change)="handleClickCheckbox(element.id, $event)"
              [checked]="element.selected">
            </mat-checkbox>
          </td>
          <td *ngFor="let row of rows; index as i;"
              (click)="handleSelectRow(element.id)"
              [innerHTML]="element[row.value]"><p>test</p>
          </td>
          <td id="delete" *ngIf="deleteSign" style="width: 50px;">
            <button
              mat-button color="primary"
              class="delete-sign"
              (click)="removeElement(element.id)">
              <fa-icon [icon]="faService.faTrashAlt" class="search-icon"></fa-icon>
            </button>
          </td>
        </tr>
      </table>
    </div>
  `,
  styleUrls: ['./table.component.scss']
})
export class TableComponent {
  @Input() isAllSelected: boolean;
  @Input() rows: {label: string, value: string}[];
  @Input() data: any[];
  @Input() checkboxSign: boolean;
  @Input() deleteSign: boolean;
  @Input() selectedShipments: number[] = [];

  @Output() deleteElement: EventEmitter<number> = new EventEmitter();
  @Output() clickCheckbox: EventEmitter<{id: number, isSelected: boolean}> = new EventEmitter();
  @Output() selectRow: EventEmitter<number> = new EventEmitter();
  @Output() selectAll: EventEmitter<boolean> = new EventEmitter();

  constructor(public faService: FontAwesomeService) {}

  removeElement(id) {
    this.deleteElement.emit(id);
  }
  handleSelectRow(id) {
    this.selectRow.emit(id);
  }
  handleClickCheckbox(id, event) {
    this.clickCheckbox.emit({id, isSelected: event.checked});
  }

  handleSelectAll(event) {
    this.selectAll.emit(event.checked);
  }

  trackByFn(index, element) {
    return element.id;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/atoms/table/table.component.ts